module.exports = __webpack_public_path__ + "static/media/farm_5_video2.584232d9.png";